module.exports = __webpack_public_path__ + "static/media/logo_ciudadanias.4eaac75c.svg";